// React
import React from 'react';
// Components
import Card from 'react-bootstrap/Card';
import Placeholder from 'react-bootstrap/Placeholder';

/**
 * The general dashboard card template used in the dashboard.
 * @component
 * @param {Object} props - The component accepts props.
 * @param {component} props.children - A component to display inside the card.
 * @param {string} props.className - Additional class names to be added above defaults.
 * @param {string} [props.cardHeader] - An optional card header title. If provided will add header to the card.
 * @param {boolean} [props.dashboardLoading] - Dashboard loading spinner state. If cardHeader is provided, this prop must be provided.
 * @param {React.RefObject<HTMLElement>} props.ref - Reference to the underlying Card element.
 * @returns A dashboard card component.
 */
const GeneralDashboardCard = React.forwardRef(({children, className, cardHeader, dashboardLoading}, ref) => {
  return (
    <Card ref={ref} border='primary' className={`shadow bg-primary-subtle ${className}`}>
      {cardHeader ?
        <Card.Header className="fw-bold">{
          dashboardLoading ?
          <Placeholder as="p" animation="wave" className='mb-0'>
            <Placeholder xs={3} />
          </Placeholder> :
          cardHeader
          }
        </Card.Header> :
        ''      
      }
      <Card.Body>
        {children}
      </Card.Body>
    </Card>
  );
});

export default GeneralDashboardCard;